import { IconButton, theme } from 'aimo-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TouchableOpacity } from 'react-native';
import { testIdentifiers } from 'utils/testIdentifiers';
import Icon from '../icons/Icon';

type FilterButtonProps = {
  onPress?: () => void;
  isActive?: boolean;
  testID?: string;
};
const FilterButton = ({
  onPress,
  isActive = false,
  testID = '',
}: FilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <TouchableOpacity
      activeOpacity={0.9}
      onPress={onPress}
      {...testIdentifiers(`${testID}-filter-button`)}>
      <IconButton
        rounded
        buttonType={isActive ? 'primary' : 'secondary'}
        fullWidth={false}
        testID="filter-icon"
        onPress={onPress}
        iconComponent={() => (
          <Icon name="Filter-Outlined" size="s" color={theme.colors.white} />
        )}
        accessibilityLabel={t('ariaLabels.map.filters.button')}
      />
    </TouchableOpacity>
  );
};

export default FilterButton;
